// To perform validations on uploaded file
// Default execution consists of validating file based on max-file-size and accepted-file-formats data attributes on file field
// and throwing alert message corresponding to size-exceeded-msg and invalid-format-msg data attributes on file field if validations fail
// Callback function can be given to prevent default execution. The callback function will be executed in this case.
// Callback function will receive object consisting isFormatValid, invalidFormatMsg, isSizeValid and sizeExceededMsg
/*
 * Dependencies
 */
var $ = require('jquery');
/*
 * Main class
 */
var FileUploadValidationHandler = {
  /**
  * This function is used to initialize the file validate plugin
  * @param {Object} $this jQuery object containing file input fields having js-file-field class
  * @param {function} postValidationCallback callback function to be executed in place of default execution
  * @returns {boolean} Operation succeeded or not
  */
  initialize: function($this, postValidationCallback) {
    $this.on('change', '.js-file-field', this.validateUploadedFile.bind(this, postValidationCallback));
    $this.on('click', '.js-remove-uploaded-file', this.removeFileLinkHandler.bind(this));
    return true;
  },
  /**
  * This function is used to execute plugin default action or execute callback if callback is provided
  * @param {function} postValidationCallback callback function to be executed in place of default execution
  * @param {Object} event object
  * @returns {Object} current instance
  */
  validateUploadedFile: function _validateUploadedFile(postValidationCallback, event) {
    var $fileField = $(event.target);
    var maxFileSize = $fileField.data('max-file-size');
    // Accepted file formats array
    var acceptedFileFormats = $fileField.data('accepted-file-formats') ? $fileField.data('accepted-file-formats').split(',') : [];
    var validationCallback = typeof postValidationCallback === 'function' ? postValidationCallback : this.defaultValidationCallback;

    validationCallback({
      isFormatValid: acceptedFileFormats.length ? this.isFormatValid($fileField.val(), acceptedFileFormats) : true,
      invalidFormatMsg: $fileField.data('invalid-format-msg') || '',
      isSizeValid: maxFileSize ? this.isSizeValid($fileField, maxFileSize) : true,
      sizeExceededMsg: $fileField.data('size-exceeded-msg') || '',
      $fileField: $fileField
    },this);

    return this;
  },
  /**
  * This function is used to validate size of file.
  * @param {Object} $fileField jQuery object corresponding to input file field
  * @param {number} maxFileSize max file size limit
  * @returns {boolean} Size if valid or not
  */
  isSizeValid: function _isSizeValid($fileField, maxFileSize) {
    if(!($fileField.get(0).files[0])){
      return true;
    }
    var fileSize = $fileField.get(0).files[0].size / 1024; // in KB
    return fileSize <= maxFileSize;
  },
  /**
  * This function is used to validate format of file.
  * @param {string} fileName name of file uploaded
  * @param {array} acceptedFileFormats acceptable file formats
  * @returns {boolean} format if valid or not
  */
  isFormatValid: function _isFormatValid(fileName, acceptedFileFormats) {
    var fileFormat = fileName.split('.').pop().toLowerCase();
    return !acceptedFileFormats.every(function(format) {
      return fileFormat !== format;
    });
  },
  /**
  * This function is used to execute plugin default action
  * @param {Object} validationsInfo object consisting isFormatValid, invalidFormatMsg, isSizeValid and sizeExceededMsg
  * @returns {Object} current instance
  */
  defaultValidationCallback: function _defaultValidationCallback(validationsInfo,_self) {
    if(validationsInfo.$fileField.val()) {
      if(!validationsInfo.isFormatValid) {
        alert(validationsInfo.invalidFormatMsg);
        validationsInfo.$fileField.val('');
      } else if(!validationsInfo.isSizeValid) {
        alert(validationsInfo.sizeExceededMsg);
        validationsInfo.$fileField.val('');
      } else {
        var fileName = validationsInfo.$fileField.val().split('\\').pop();
        var $attachBillSection = validationsInfo.$fileField.parents('.js-attach-bill-section');
        $attachBillSection.find('.js-file-name-field').val(fileName);
        $attachBillSection.find('.js-remove-file-section').removeClass('l-display-none').find('.js-uploaded-file-name').text(fileName);
      }
    } else {
      _self.removeUploadedFile(validationsInfo.$fileField);
    }
    return this;
  },
  /**
  * This function is used to handle click on remove link
  * @param {Object} event object
  * @returns {boolean} returns false to stop event default action
  */
  removeFileLinkHandler: function _removeFileLinkHandler(event) {
    event.preventDefault();
    this.removeUploadedFile($(event.target).parents('.js-attach-bill-section').find('.js-file-field'));
    return false;
  },
  /**
  * This function is used to remove uploaded file
  * @param {Object} jQuery object for input file field
  * @returns {boolean} returns current instance
  */
  removeUploadedFile: function _removeUploadedFile($fileField) {
    var $attachBillSection = $fileField.parents('.js-attach-bill-section');
    $fileField.val('');
    $attachBillSection.find('.js-file-name-field').val('');
    $attachBillSection.find('.js-remove-file-section').addClass('l-display-none');
    return this;
  }
}

module.exports = FileUploadValidationHandler;